import { TServices } from "types/terms/termsTypes";

export const totalServices = [
  {
    label: "에너지엑스",
    value: "ENERGYX",
    path: process.env.ENERGYX_URL,
    logo: "https://s3.ap-northeast-2.amazonaws.com/energyx.file/assets/logos/energyx-logo.svg",
  },
  {
    label: "내일의 건축",
    value: "TOMARCH",
    path: process.env.TOMARCH_URL,
    logo: "https://s3.ap-northeast-2.amazonaws.com/xtudy.file/logo/tomarch_logo_small.png",
    logo_m: "https://s3.ap-northeast-2.amazonaws.com/xtudy.file/logo/tomarch_logo_without_desc.png",
  },
  {
    label: "디자인후즈",
    value: "DESIGN_WHOS",
    path: process.env.DESIGN_WHOS_URL,
    logo: "https://s3.ap-northeast-2.amazonaws.com/xtudy.file/logo/design_whos_logo.png",
  },
] satisfies { label: string; value: TServices; path?: string; logo: string; logo_m?: string }[];
